const Actions = {
  FETCH_ALL_LEADS: "FETCH_ALL_LEADS",
  FETCH_ALL_LEADS_SUCCESS: "FETCH_ALL_LEADS_SUCCESS",
  FETCH_ALL_LEADS_FAILURE: "FETCH_ALL_LEADS_FAILURE",
};

export default Actions;
